import request from "@/utils/request";

// 列表(主数据列表)
export function loadRetailSurveyInfoListDataApi(data) {
  return request({
    url: "web/retailSurveyInfo/listData",
    method: "post",
    data
  });
}
// 导出
export function loadRetailSurveyInfoExportDataApi(data) {
  return request({
    url: "web/retailSurveyInfo/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateRetailSurveyInfoApi(data) {
  return request({
    url: "web/retailSurveyInfo/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initRetailSurveyInfoApi(data) {
  return request({
    url: "web/retailSurveyInfo/init",
    method: "post",
    data
  });
}

// 根据条件查询零售监测
export function findRetailSurveyInfoByConditionApi(data) {
  return request({
    url: "web/retailSurveyInfo/findListByCondition",
    method: "post",
    data
  });
}

// 根据条件查询地图用零售监测
export function findRetailSurveyInfoByMapApi(data) {
  return request({
    url: "web/retailSurveyInfo/findListByMap",
    method: "post",
    data
  });
}

// 明细列表(主数据列表)
export function loadRetailSurveyItemListDataApi(data) {
    return request({
      url: "web/retailSurveyItem/listData",
      method: "post",
      data
    });
  }
// 导出
export function loadRetailSurveyItemExportDataApi(data) {
  return request({
    url: "web/retailSurveyItem/exportData",
    method: "post",
    data
  });
}
// 根据条件查询明细
export function findRetailSurveyItemByConditionApi(data) {
  return request({
    url: "web/retailSurveyItem/findItemsByCondition",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateRetailSurveyItemApi(data) {
  return request({
    url: "web/retailSurveyItem/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initRetailSurveyItemApi(data) {
  return request({
    url: "web/retailSurveyItem/init",
    method: "post",
    data
  });
}

// 导出周期列表(主数据列表)
export function loadRetailSurveyExportCycleSettingListDataApi(data) {
  return request({
    url: "web/retailSurveyExportCycleSetting/listData",
    method: "post",
    data
  });
}
// 导出
export function loadRetailSurveyExportCycleSettingExportDataApi(data) {
  return request({
    url: "web/retailSurveyExportCycleSetting/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateRetailSurveyExportCycleSettingApi(data) {
  return request({
    url: "web/retailSurveyExportCycleSetting/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initRetailSurveyExportCycleSettingApi(data) {
  return request({
    url: "web/retailSurveyExportCycleSetting/init",
    method: "post",
    data
  });
}

// 周期设置下拉
export function loadRetailSurveyExportCycleSettingSelectDataApi(data) {
  return request({
    url: "web/retailSurveyExportCycleSetting/listSelectData",
    method: "post",
    data
  });
}

// 导出报告
export function loadRetailSurveyInfoExportReportDataApi(data) {
  return request({
    url: "web/retailSurveyInfo/exportReportData",
    method: "post",
    data
  });
}